const shouldShowMapForCategoryName = (categoryName: string) =>
  ['Food', 'Gas', 'Grocery'].includes(categoryName);

export default shouldShowMapForCategoryName;
